const TWENTY_MINUTES = 1200000;

export const ProductName = {
  BusinessHealth: "Business Health",
  BusinessProtect: "Business Protect"
};

export const CustomerType = {
  BusinessHealth: "Business_Health",
  BusinessProtect: "Business_Protect"
};

export const LoginStatus = {
  Valid: "Valid",
  PolicyLocked: "PolicyLocked",
  InvalidPolicyStatus: "InvalidPolicyStatus",
  InvalidDetails: "InvalidDetails",
  Locked: "Locked",
  RestrictedPolicy: "RestrictedPolicy",
  RestrictedGroup: "RestrictedGroup",
  Restricted: "Restricted",
  SessionFailure: "SessionFailure",
  SessionTimeout: "SessionTimeout",
  SystemUnavailable: "SystemUnavailable",
  MovedToAxaHealth: "MovedToAxaHealth"
};

export const Layouts = {
  HOL: "HOL",
  MOL: "MOL"
};
export const PolicyType = {
  Individual: "Individual",
  LargeCorporate: "LargeCorporate",
  SME: "SME",
  International: "International"
};

export const DateTimeFormats = {
  apiMask: "YYYY-MM-DD 00:00:00",
  apiMaskWithTime: "YYYY-MM-DD HH:mm:ss",
  apiMaskWithDateForDisplay: "DD/MM/YYYY",
  apiMaskWithTimeForDisplay: "HH:mm",
  apiMaskWithDateAndTimeForDisplay: "DD/MM/YYYY \\at HH:mm:ss",
  apiMaskSplitterFullDateRegex: "-",
  apiMaskSplitterDayRegex: " "
};

export const ChangeAddressStatus = {
  PostCodeInvalid: "PostCode"
};

export const MyProfileChangeIndicator = {
  EmailAddress: "EmailAddress",
  Address: "Address",
  Phone: "Phone",
  Password: "Password",
  Bank: "BankDetails"
};

export const AddAPlanValidationStatus = {
  PlanAlreadyAdded: "PlanAlreadyAdded",
  PlanAlreadyLinkedToOther: "PlanAlreadyLinkedToOther",
  Locked: "Locked",
  AddPlanSuccess: "AddPlanSuccess",
  AddPlanSuccessForNoAccessPolicy: "AddPlanSuccessForNoAccessPolicy",
  AddPlanSuccessForMovedToAxaHealth: "AddPlanSuccessForMovedToAxaHealth",
  Error: "Error",
  PlanAlreadyRegisteredInSF:"PlanAlreadyRegisteredInSF",
  PlanNotLinkedToSameAccountInSF:"PlanNotLinkedToSameAccountInSF",
  RecordNotFoundInSF:"RecordNotFoundInSF",
  UnableToMatchBySystemRecord : "UnableToMatchBySystemRecord"
};
export const PageAreas = {
  FaqAreaCoverPage: "Cover_details",
  FaqAreaTreatmentPage: "My_treatments",
  FaqAreaMyAccountPage: "My_account",
  FaqAreaMyPersonalDetailsPage: "Personal_details",
  FaqAreaShortFallPage: "Payment_details_shortfall",
  FaqAreaNoShortFallPage: "Payment_details_no_shortfall"
};

export const InboxPages = {
  AskAMedicalExpertPage: "askExpert",
  Complaints: "complaint",
  GeneralQuery: "generalQuery",
  HomePage: "home",
  PlanChanges: "planChanges",
  SubmitInvoice: "uploadDocument"
};

export const NetworkTimeout = TWENTY_MINUTES;
export const NotificationUpdateThreshold = TWENTY_MINUTES;
export const MessagesUpdateThreshold = TWENTY_MINUTES;

export const infoOverlayCookie = {
  name: "infoOverlay",
  value: "accepted",
  expiryYear: 1
};


export const Menu = {
  Home: "Home",
  Cover: "Cover",
  Claims: "Claims",
  HealthSupport: "HealthSupport",
  HealthStore: "HealthStore",
  ContactUs: "ContactUs",
  Help: "Help"
};

export const XsrfTokenStorageName = "XSRF_TOKEN";
export const XsrfTokenRequestValue = "request";
export const SystemUnavailable = "SystemUnavailable";
export const ChangeAddressContent = "ChangeAddressContent";
export const InsideUKContent = "InsideUKContent";
export const ChannelIslandsContent = "ChannelIslandsContent";
export const ValidationContent = "ValidationContent";

export const SubBenefits = {
  StrongerMinds: "StrongerMinds"
};

export const B2CSessionTimeOutError = "interaction_required";
export const B2COIDCClientStateNotFoundError =
  "No matching state found in storage";
export const B2COIDCClientIatIsInFutureError = "iat is in the future";
export const B2COIDCClientExpIsInPastError = "exp is in the past";

export const B2CErrorResponseCodes = {
  ForgottenPassword: "AADB2C90118",
  changePasswordMaxRetry: "AADB2C90157",
  CancelButton: "AADB2C90091"
};

export const OnboardingResponseStatus = {
  NoAccessToPolicy: "NoAccessToPolicy",
  RestrictedGroup: "RestrictedGroup",
  RestrictedPolicy: "RestrictedPolicy",
  LockedPolicy: "LockedPolicy",
  UserExistsButIsNotReset: "UserExistsButIsNotReset",
  OnboardingFailed: "OnboardingFailed",
  OnboardingFailedHybridDataMismatch: "OnboardingFailedHybridDataMismatch",
  UnabletoMatchbySystemRecord:"UnableToMatchBySystemRecord",
  InvalidMemberDetails: "InvalidMemberDetails",
  UserExistinSF: "UserExistinSF",
  policyNotLinkedToSameAccountinSF:"policyNotLinkedToSameAccountinSF"
};

export const UserStatus = {
  Reset: "Reset",
  UserDoesNotExist: "UserDoesNotExist"
};

export const BrandTypes = {
  AXA: "AXA Health",
  HOL: "Health-on-Line"
};


export const ButtonConfig= {
  Setupthisservice :"cta_mol_dh_suserv",
  BookanAppoint:"cta_mol_dh_bookap",
  AppStore:"cta_mol_dh_apst",
  GooglePlay:"cta_mol_dh_glpl",
  MoreAboutService:"cta_mol_dh_dhmo",
  PromoMoreAboutService:"cta_mol_dh_hbsb",
  SpeakToanExpert:"cta_mol_dh_spexp",
  DocterAtAnywhere:"cta_mol_dh_dca", 
  EDCABarcalys:"cta_mol_dh_bl",
  MskMakeAppointmentContent:"cta_mol_msk_appt",
  MskHowItswork :"cta_mol_msk_hw",
  MskMakeAppointment:"cta_mol_msk_appm",
  MskMore:"cta_mol_msk_faq",
  HatHPromo:"cta_mol_247_msk",
  TwentyfourCallh:"cta_mol_247_callh",
  TwentyfourMessh:"cta_mol_247_messh",
  TwentyfourCallb:"cta_mol_247_callb",
  TwentyfourMessb:"cta_mol_247_messb",
  Twentyfourcallc4c:"cta_mol_247_callc4c",
  Twentyfourcallcardiac:"cta_mol_247_callcardiac",
  HomeIndcta_mol_hp_livechat:"cta_mol_hp_livechat",
  HomeIndcta_mol_hp_vcl:"cta_mol_hp_vcl",
  HomeIndcta_mol_hp_inbox:"cta_mol_hp_inbox",
  HomeIndcta_mol_hp_trco:"cta_mol_hp_trco",
  HomeIndcta_mol_hp_docs:"cta_mol_hp_docs",
  HomeIndcta_mol_hp_dh:"cta_mol_hp_dh",
  HomeIndcta_mol_hp_cp:"cta_mol_hp_cp",
  HomeIndcta_mol_hp_mess:"cta_mol_hp_mess",
  MSkpromo:"cta_mol_gen_msk",
  contactUs:"cta_mol_hp_mm_conus",
  carcta_mol_hp_mm_msk:"cta_mol_hp_mm_msk",
  carcta_mol_hp_mm_dh:"cta_mol_hp_mm_dh",
  carcta_mol_hp_mm_c4c:"cta_mol_hp_mm_c4c",
  carcta_mol_hp_mm_c4cp:"cta_mol_hp_mm_c4cp",
  carcta_mol_hp_mm_247:"cta_mol_hp_mm_247",
  carcta_mol_hp_mm_ass:"cta_mol_hp_mm_ass",
  carcta_mol_hp_mm_denc:"cta_mol_hp_mm_denc",
  carcta_mol_hp_mm_raf:"cta_mol_hp_mm_raf",
  carcta_mol_hp_mm_gym:"cta_mol_hp_mm_gym",
  carcta_mol_hp_mm_tc:"cta_mol_hp_mm_tc",
  carcta_mol_hp_mm_bk:"cta_mol_hp_mm_bk",
  carcta_mol_hp_mm_rab:"cta_mol_hp_mm_rab",
  AddBankDetails:"cta_mol_profile_addbank",
    ChangeBankDetails:"cta_mol_profile_changebank",
  ChangeBankDetailsSubmit:"cta_mol_changebank_submit",
  ClaimBackAddBankDetails:"cta_mol_claim_claimback_addbank",
  ClaimBackUpdateBankDetails:"cta_mol_claim_claimback_updatebank",
  UploadAGPreferralletter :"cta_mol_cu_uploadgpref",
  MakeAclaim :"cta_mol_cu_makeclaim",
  AskAMedQuestion:"cta_mol_cu_askmedq",
  GeneralEnquiry:"cta_mol_cu_genenquiry",
  Iamdissatisfied:"cta_mol_cu_dissatisfied",
  GPAppointments247:"cta_mol_hs_gpapp247",
  HealthSupportlineWorried:"cta_mol_hs_hsline247",
  BreastCancerDiagnosticService:"cta_mol_hs_breastc4c",
  ProstateCancerDiagnosticService:"cta_mol_hs_prostatec4c",
  SkinCancerDiagnosticService:"cta_mol_hs_skinc4c",
  HealthSupportLineUnwelll:"cta_mol_hs_2hsline247",
  GPAppointments247Unwell:"cta_mol_hs_2gpapp247",
  SpeakToAPhysiotherapist:"cta_mol_hs_mbj",
  SpecialistAppointmentBookingService:"cta_mol_hs_specialistappt",
  HealthSupportLineRecover:"cta_mol_hs_3hsline247",
  ContactUsButton:"cta_mol_hs_contactus",
  OnboardingNeedHelp:"cta_molonboarding_needhelp",
  LiveChatContactUs:"cta_contactus_livechat"
};

export const CommunicationPref ={
  NoThanks: "0",
  DocumentsInBraille: "1",
  DocumentsInLargePrint: "2",
  Audio:"3",
  SignLanguageService: "4",
  Dyslexic:"5",
  RelayUK: "7"
};